// These values will be replaced during build but work for local dev
export const BUILD_TIMESTAMP = '2025-08-20T04:52:31.719Z';
export const APP_VERSION = '1.99.149'; // Updated version to match package.json
export const CACHE_VERSION = `${APP_VERSION}-${BUILD_TIMESTAMP}`;

// Database constants
export const DB_NAME = 'elderly-services';
export const DB_VERSION = 1;
export const STORE_NAME = 'app-data';
export const DATA_KEY = 'servicesData';
export const LAST_UPDATED_KEY = 'lastUpdated';
export const VERSION_KEY = 'appVersion';
export const ALL_SERVICES_KEY = 'allServicesData';
export const CATEGORIES_KEY = 'categories';

// Icons mapping
export const categoryIcons = {
    'default': '📌'
};
